import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import './App.css';
import logo from './img/name.png';
import Home from './Home';
import About from './About';
import Pricing from './Pricing';
import chatLogo from './img/chat_logo.svg';

function CookieBanner({ onClose }) {
  return (
    <div className="cookie-banner">
      <p>Мы используем cookies для улучшения работы сайта. Продолжая пользоваться сайтом, вы соглашаетесь с использованием cookies.</p>
      <button onClick={onClose}>Понятно</button>
    </div>
  );
}

function App() {
  const [showCookie, setShowCookie] = useState(false);

  useEffect(() => {
    const accepted = sessionStorage.getItem('cookieAccepted');
    if (!accepted) {
      setShowCookie(true);
    }
  }, []);

  const handleCookieClose = () => {
    sessionStorage.setItem('cookieAccepted', 'true');
    setShowCookie(false);
  };

  return (
    <Router>
      <div className="page-wrapper">
        <Helmet>
          <title>AILINK.SERVICES</title>
          <meta name="description" content="ИИ Консультант — ваш помощник в бизнесе." />
        </Helmet>

        {/* Navigation Menu */}
        <header className="header">
          <div className="container">
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <img src={logo} className="site-logo" alt="ИИ Консультант Logo" />
              <h1 style={{ fontSize: '15px' }}>AILINK.SERVICES</h1>
            </div>
            <nav className="nav">
              <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} end>
                Главная
              </NavLink>
              <NavLink to="/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                О нас
              </NavLink>
              <NavLink to="/pricing" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Стоимость
              </NavLink>
            </nav>
          </div>
        </header>

        {/* Routes */}
        <main className="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
          </Routes>
        </main>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <p>© 2025 Ailink. Все права защищены. Email: servicesailink@gmail.com</p>
  
          </div>
        </footer>

        {/* Chat Icon */}
        <div className="ai-open">
          <a
            style={{
              color: 'blue',
              display: 'flex',
              flexDirection: 'column',
              textDecoration: 'none',
              color: 'inherit',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            href="https://t.me/sofiya_cosmetic"
          >
            <img src={chatLogo} alt="consultant" width="30" height="30" />
            <span style={{ display: 'flex', fontSize: '12px' }}>Чат с ИИ</span>
          </a>
        </div>

        {/* Cookie Banner */}
        {showCookie && <CookieBanner onClose={handleCookieClose} />}
      </div>
    </Router>
  );
}

export default App;
